import { useEffect } from 'react';

const RootPath = '/';

export const useImpersonalization = () => {
    // INFO: Impersonalization feature
    useEffect(() => {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if (params.token && window.location.pathname === RootPath) {
            localStorage.setItem('user', JSON.stringify({ token: params.token }));
        }
    }, []);
};
